import React, { Component } from 'react';
import axios from '../../shared/axios/axios';
import newAxios from '../../shared/axios/new-api-axios';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import { Modal } from 'antd';

import * as actions from './store/actions';
import * as sharedActions from '../../shared/store/actions';

import withErrorHandler from '../../hoc/withErrorHandler';

import CustomForm from './custom-form';

import { isGuid } from '../../shared/utils';

import './styles.less';

const { confirm } = Modal;

let root;

class CustomFormComponent extends Component {
  componentDidMount() {
    const { getPermissions, getCustomForm, formId } = this.props;

    getPermissions();

    if (isGuid(formId)) {
      getCustomForm({ formId });
    }
  }

  onCancelClick = () => {
    const { rootContainer, redirectUrl } = this.props;

    confirm({
      getContainer: rootContainer,
      title: 'All changes will be lost. Are you sure you want to Cancel?',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      },
    });
  };

  render() {
    const { customForm, customFormLoading, rootContainer, formId, redirectUrl } = this.props;

    return (
      <div className="custom-form-div">
        <CustomForm
          form={customForm}
          rootContainer={rootContainer}
          formLoading={customFormLoading}
          onCancelClick={this.onCancelClick}
          formId={formId}
          redirectUrl={redirectUrl}
          isNewForm={!isGuid(formId)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.permissions.permissions,
    customForm: state.customForm.customForm,
    customFormLoading: state.customForm.customFormLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPermissions: () => dispatch(sharedActions.getPermissions()),
    getCustomForm: (request) => dispatch(actions.getCustomForm(request)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(hot(withErrorHandler(CustomFormComponent, axios, root, newAxios)));
